// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b0eb4496","453":"205bf84c","732":"5aa99210"}[chunkId] + ".chunk.js";
};